"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _Notifications = require("../../../../Notifications"),
    _ConfirmationModal = _interopRequireDefault(require("../../../../ConfirmationModal")),
    _confirmActions = _interopRequireDefault(require("../constants/confirmActions"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function getSubtitle(a, b) {
  return _react["default"].createElement("span", null, a, _react["default"].createElement("strong", null, b), ".");
}

var ConfirmationModal = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.handleActionRequest = (0, _lodash["default"])(function (a) {
      return (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b() {
        var c, e, f, g, h, i, j;
        return _regenerator["default"].wrap(function (b) {
          for (;;) {
            switch (b.prev = b.next) {
              case 0:
                return c = d.props, e = c.assetId, f = c.onConfirmation, g = c.hideModal, b.next = 3, a(e);

              case 3:
                if (h = b.sent, i = h.data, j = h.error, i && !j) {
                  b.next = 8;
                  break;
                }

                return b.abrupt("return", (0, _Notifications.notify)({
                  content: j,
                  type: "error"
                }));

              case 8:
                return f(), b.abrupt("return", g());

              case 10:
              case "end":
                return b.stop();
            }
          }
        }, b);
      }));
    }), d.getModalProps = function () {
      var a = d.props,
          b = a.confirmModalAction,
          c = a.archiveAsset,
          e = a.unarchiveAsset,
          f = a.organisationName;
      return b === _confirmActions["default"].ARCHIVE ? {
        onSave: d.handleActionRequest(c),
        subtitle: getSubtitle("Archiving this asset will make this hidden from view from everyone within ", f)
      } : b === _confirmActions["default"].UNARCHIVE ? {
        onSave: d.handleActionRequest(e),
        subtitle: getSubtitle("Unarchiving this asset will make this visible for everyone within ", f)
      } : {};
    }, a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.visible,
          c = a.hideModal,
          d = a.confirmModalAction;
      return _react["default"].createElement(_ConfirmationModal["default"], (0, _extends2["default"])({
        visible: b && d !== _confirmActions["default"].DELETE,
        onClose: c,
        title: "Are you sure?",
        saveBtnText: "Continue"
      }, this.getModalProps()));
    }
  }]), b;
}(_react.Component),
    _default = ConfirmationModal;

exports["default"] = _default;